import React from "react";
import { connect } from "react-redux";
import "./PopUpModal.scss";
import { actions } from "./Redux/store";

export function PopUpModal({ Component, isOpen, closeModal }) {
  if (!isOpen) return null;

  return (
    <div className="modal-backdrop">
      <div className="modal-container">
        <button className="modal-close-btn" onClick={() => closeModal()}>
          X
        </button>
        <Component />
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  Component: state.Component,
  isOpen: state.isOpen
});

const mapDispatchToProps = (dispatch) => ({
  closeModal() {
    dispatch(actions.CloseModal());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(PopUpModal);
